import { render, staticRenderFns } from "./MainNavbarNotifications.vue?vue&type=template&id=485d4116"
import script from "./MainNavbarNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavbarNotifications.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports